import { Flex, Text } from "@chakra-ui/react";
import { DroppableBox } from "components/containers/InspectionFormat/containers/LayoutFrameBuilder";
import { SOURCE } from "components/containers/InspectionFormat/Content/SettingPinLayoutFrame/context/pinLayoutFrameReducer";
import ja from "date-fns/locale/ja";
import { TimeAdditionalInfo } from "interfaces/models/inspectionItemResult";
import { registerLocale } from "react-datepicker";
import FieldPreviewWrapper from "../../../components/FieldPreviewWrapper";
import { FieldPreviewProps } from "../../types";
import TimePicker from "components/TimePicker";
import { memo, useState } from "react";
import { TimeIcon } from "components/icon";

registerLocale("ja", ja);

interface TimePreviewerProps extends FieldPreviewProps<string> {}

const TimePreviewer: React.FC<TimePreviewerProps> = ({
  item,
  value,
  isReadOnly,
  isLoading,
  isDraggable,
  index,
  allItemResultCount,
  prevItemResultCount,
  onChange,
}) => {
  const additionInfo = item.additionInfo as TimeAdditionalInfo;
  const [isShowCalendar, setIsShowCalendar] = useState<boolean>(false);

  if (isDraggable) {
    return (
      <>
        <FieldPreviewWrapper
          title={item.name}
          index={index}
          prevItemResultCount={prevItemResultCount}
          allItemResultCount={allItemResultCount}
          data-type={item.dataType}
        >
          <DroppableBox
            flex={1}
            name={item.name}
            icon={<TimeIcon color="#525252" w="3rem" h="3rem" />}
            id={item.id}
            source={SOURCE.INSPECTION_FORM}
          >
            <Flex
              className="draggable-area"
              alignItems="center"
              backgroundColor="white"
              height="4rem"
              maxWidth="100%"
              width="100%"
              fontSize="1rem"
              color="#171717"
              border="1px solid #D4D4D4"
              padding="6px 10px 5px 0px"
            >
              <TimeIcon width="2.4rem" height="2.4rem" padding="0.5rem" />
              <Text color="#A3A3A3">時間</Text>
            </Flex>
          </DroppableBox>
        </FieldPreviewWrapper>
      </>
    );
  }

  return (
    <FieldPreviewWrapper
      index={index}
      prevItemResultCount={prevItemResultCount}
      allItemResultCount={allItemResultCount}
      title={item.name}
    >
      <TimePicker
        showIcon
        isShowCalendar={isShowCalendar}
        setIsShowCalendar={setIsShowCalendar}
        placeholderText="時間"
        formatType={additionInfo.formatType}
        value={value}
        isLoading={isLoading}
        isReadOnly={isReadOnly}
        onChange={onChange}
      />
    </FieldPreviewWrapper>
  );
};

export default memo(TimePreviewer);
